import React from 'react';
import { X, AlertCircle, AlertTriangle, CheckCircle, Info } from 'lucide-react';
import { useNotifications } from '../../context/NotificationContext';

/**
 * AlertBar - Renders header alerts (top center)
 *
 * Types: error, warning, success, info, confirm
 * Confirmations include Yes/No action buttons
 */
const AlertBar = () => {
  const { alerts, dismissAlert } = useNotifications();

  if (alerts.length === 0) return null;

  const getIcon = (type) => {
    switch (type) {
      case 'error':
        return <AlertCircle size={18} />;
      case 'warning':
        return <AlertTriangle size={18} />;
      case 'success':
        return <CheckCircle size={18} />;
      case 'confirm':
        return <AlertTriangle size={18} />;
      case 'info':
      default:
        return <Info size={18} />;
    }
  };

  const handleConfirm = (alert) => {
    if (alert.onConfirm) {
      alert.onConfirm();
    }
    dismissAlert(alert.id);
  };

  const handleCancel = (alert) => {
    if (alert.onCancel) {
      alert.onCancel();
    }
    dismissAlert(alert.id);
  };

  return (
    <div className="alert-bar">
      {alerts.map((alert) => (
        <div key={alert.id} className={`alert-item alert-${alert.type}`}>
          <span className="alert-icon">{getIcon(alert.type)}</span>
          <span className="alert-message">{alert.message}</span>

          {alert.type === 'confirm' ? (
            <div className="alert-actions">
              <button
                className="alert-btn alert-btn-confirm"
                onClick={() => handleConfirm(alert)}
              >
                {alert.confirmText}
              </button>
              <button
                className="alert-btn alert-btn-cancel"
                onClick={() => handleCancel(alert)}
              >
                {alert.cancelText}
              </button>
            </div>
          ) : (
            <button
              className="alert-dismiss"
              onClick={() => dismissAlert(alert.id)}
              title="Dismiss"
            >
              <X size={16} />
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default AlertBar;
